__turbopack_context__.v({
  "animate-play-pulse": "VideoOverlay-module__PfNfWW__animate-play-pulse",
  "pulse": "VideoOverlay-module__PfNfWW__pulse",
});
